import { useTranslation } from 'react-i18next'
import { useNavigate } from '@tanstack/react-router'
import clsx from 'clsx'
import { planSeed } from 'shared/plan-seed'
import { toast } from 'ui/sonner'

import { apiClient } from '~/api/client'
import { PlanCard } from '~/boundedContext/subscription/components/plan-card'
import { LinkButton } from '~/components/link-button'
import { LS_JWT_KEY } from '~/const/api'
import { MobileBottomLayout } from '~/layout/mobile-bottom'
import { useAccountStore } from '~/stores/account'

export const ChangeSubscriptionPage = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const accountPlanId = useAccountStore(state => state.planId)
  const revalidateAccount = useAccountStore(state => state.revalidateAccount)
  const patchAccount = useAccountStore(state => state.patchAccount)

  // TODO: some loading state
  if (!accountPlanId) return null

  return (
    <MobileBottomLayout>
      <header className="text-center">
        <h1 className="text-2xl font-bold">{t('Change subscription')}</h1>
      </header>
      <section className="flex w-full flex-wrap justify-center gap-4 md:gap-8">
        {planSeed.map(
          plan =>
            plan.id !== accountPlanId && (
              <PlanCard
                key={plan.id}
                buttonText={t('Change Plan')}
                className={clsx(
                  'hover:scale-100',
                  plan.name === 'Basic Plan' &&
                    'bg-gradient-to-r from-blue-100 to-indigo-100 dark:from-blue-900 dark:to-indigo-900',
                )}
                coins={plan.coins}
                onSelect={() =>
                  apiClient
                    .POST('/subscription', {
                      body: { planId: plan.id },
                      onBadResponse: () => toast.error(t('Something went wrong')),
                    })
                    .then(({ data }) => {
                      if (!data) {
                        toast.error(t('Something went wrong'))

                        return
                      }

                      if ('jwtToken' in data && data.jwtToken) {
                        localStorage.setItem(LS_JWT_KEY, data.jwtToken)
                        patchAccount({ coins: plan.coins, planId: plan.id, planCoins: plan.coins })
                        void revalidateAccount()

                        return navigate({ to: '/settings/subscription/usage' })
                      }

                      if ('clientSecret' in data && data.clientSecret)
                        void navigate({
                          to: '/subscription/checkout',
                          search: { clientSecret: data.clientSecret, redirectTo: '/settings/subscription/usage' },
                        })
                    })
                }
                price={plan.name === 'Basic Plan' ? 1 : 0}
                title={plan.name}
              />
            ),
        )}
      </section>
      <section className="flex max-w-md flex-col gap-4">
        <LinkButton to="/settings/subscription/usage" variant="outline">
          {t('Back')}
        </LinkButton>
      </section>
    </MobileBottomLayout>
  )
}
